export const useReservationStore = defineStore('reservation', () => {
  const voucher = ref<any>(null)
  const manufacturers = ref<Array<any>>([])
  const contractors = ref<Array<any>>([])

  const getVoucher = (data: any) => {
    voucher.value = data.voucher
    manufacturers.value = data.manufacturers
    contractors.value = data.contractors
  }

  const reset = () => {
    voucher.value = null
    manufacturers.value = []
    contractors.value = []
  }

  return { voucher, manufacturers, contractors, getVoucher, reset }
})
